import Box from "@mui/material/Box";
import {FC, useCallback, useContext, useEffect, useState} from "react";
import {makeStyles} from "tss-react/mui";
import {Modal} from "@buildwitt/shapeshift-common/v2/modal";
import {Button, FormControlLabel, LinearProgress, Radio, RadioGroup, Typography} from "@mui/material";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {Dayjs} from "dayjs";
import {INotificationSeverity, NotificationContext, useApi} from "@buildwitt/shapeshift-identity";

interface IProps {
	open: boolean,
	playlistId: number,
	onClose: (reload?: boolean) => void,
	selected: number[]
}

const useStyles = makeStyles()((theme) => ({
	adminBulkEnrollmentModal: {
		padding: theme.spacing(3),
		display: "flex",
		gap: theme.spacing(2),
		flexDirection: "column"
	}
}));

type IAdminUserBulkActionAddToTrainingFeedResponse = any //to do

export const AdminBulkPlaylistEnrollmentModal: FC<IProps> = ({open, playlistId, selected, onClose}) => {
	const {classes} = useStyles();
	const {notify} = useContext(NotificationContext);
	const [enrollResponse, submitDueDateApi] = useApi<IAdminUserBulkActionAddToTrainingFeedResponse[]>()

	useEffect(() => {
		if(enrollResponse.statusCode === 200){
			notify("", "Successfully enrolled users", INotificationSeverity.success, 5000)
			onClose(true)
		}
		else if(enrollResponse.statusCode){
			notify("", "Failed to enroll users", INotificationSeverity.error, 5000)
			onClose()
		}
	}, [enrollResponse])

	const handleSubmitPrioritizeEnroll = useCallback(() => {
		if(!open || enrollResponse.isLoading)
			return;

		submitDueDateApi({
			url: "/api/user/bulk/playlist/enroll/prioritise",
			method: "POST",
			data: {
				playlist: playlistId,
				users: selected
			}
		})
	}, [open, playlistId, enrollResponse.isLoading])

	return (
		<Modal
			open={open}
			footerButtons={[
				<Button key={1} onClick={() => onClose()}>CANCEL</Button>,
				<Button key={2} onClick={() => handleSubmitPrioritizeEnroll()}>CONFIRM</Button>
			]}
			onClose={() => onClose()}
			aria-labelledby="modal-modal-title"
			title="Confirm Bulk Enrollment"
			aria-describedby="modal-modal-description"
		>
			<Box className={classes.adminBulkEnrollmentModal}>
				<Typography variant="h5">Confirm Bulk Enrollment</Typography>
				<Typography paddingTop={1}>
					Enrolling a user onto a playlist will add training to the top of your employee&apos;s training feed.<br />
					<br />
					Important: Please note that prioritizing courses may push other items down the list and impact other courses due dates.
				</Typography>
				<Typography>
					<li>[{selected.length}] users selected</li>
				</Typography>
				{enrollResponse.isLoading && <LinearProgress />}
			</Box>
		</Modal>
	);
}